import {Component, Input, OnInit} from '@angular/core';

export enum OnlineStatus {
  NONE,
  ONLINE,
  OFFLINE,
}

export interface Chip {
  text: string;
  color: string;
  callback?: () => void;
}

@Component({
  selector: 'app-list-view-element',
  templateUrl: './list-view-element.component.html',
  styleUrls: ['./list-view-element.component.scss']
})
export class ListViewElementComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  subtitle: string;

  @Input()
  icon: string;

  @Input()
  chips: Chip[];

  @Input()
  onlineStatus: OnlineStatus = OnlineStatus.NONE;

  constructor() { }

  ngOnInit(): void {
  }

  getOnlineStatus() {
    return OnlineStatus;
  }

}
